var _a, _b;
import { __assign } from "tslib";
import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { resetEditorPublishResults, publishComment, publishCommentFailure, publishCommentSuccess, focusEditor, focusDone, } from './actionCreators';
var actionHandlers = handleActions((_a = {},
    _a[publishComment.toString()] = function (state) { return (__assign(__assign({}, state), { isBusy: true, publishResult: null, isError: false, errorMsg: null })); },
    _a[publishCommentSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { isBusy: false, publishResult: action.payload, isError: false, errorMsg: null })); },
    _a[publishCommentFailure.toString()] = function (state, action) {
        ddt.log('comments', 'Failed to post comment', action);
        return __assign(__assign({}, state), { isBusy: false, publishResult: null, isError: true, errorMsg: action.payload.errorMsg });
    },
    _a[resetEditorPublishResults.toString()] = function (state) { return (__assign(__assign({}, state), { isBusy: false, publishResult: null, isError: false, errorMsg: null })); },
    _a[focusEditor.toString()] = function (state) { return (__assign(__assign({}, state), { isFocusRequested: true })); },
    _a[focusDone.toString()] = function (state) { return (__assign(__assign({}, state), { isFocusRequested: false })); },
    _a), {
    isBusy: false,
    publishResult: null,
    isError: false,
    errorMsg: null,
    isFocusRequested: false,
});
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = {}; }
        // Server errors if we don't check for an undefined action here.
        if (!action || !action.payload || !action.type) {
            return state;
        }
        var editorId = action.payload.editorId;
        if (!editorId) {
            return state;
        }
        var innerState = state[editorId];
        var newInnerState = actionHandlers(innerState, action);
        return __assign(__assign({}, state), (_a = {}, _a[editorId] = newInnerState, _a));
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map